export default {
  CREATE: `Créer une donnée d'embauche`,
  DELETE_BUTTON: {
    TITLE: `Supprimer la donnée d'embauche`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette donnée d'embauche ?`,
    PRIMARY_ACTION: `Supprimer la donnée d'embauche`
  },
  LIST: {
    TITLE: `Liste des données d'embauche`
  },
  TYPE: `Type`,
  DESCRIPTION: `Description`,
  HAS_VALID_PERIOD: `Période de validité`,
  NB_HOURS_MIN: `Nombre d'heures minimal`,
  NB_HOURS_MAX: `Nombre d'heures maximal`,
  DISPONIBILITY_APPROVED_DEFAULT: `Disponibilité approuvée automatiquement`,
  NOT_UPDATE_AVAILABILITY: `Ne peut pas modifier ses disponibilités`,
  SEND_EXPIRED_EMAILS: `Envoyer un courriel lorsqu'expirée`,
  MIN_DISTANCE_BETWEEN_SHIFTS: `Distance minimale entre les quarts de travail`,
  FALLBACK_ID: `Fallback`,
  CONTRACTTYPE: `Contrat`,
  PERMITTYPE: `Permis`,
  EMPLOYEETYPE: `Employé`,
  SUBMIT_AVAILABILITIES_ADVANCE: `Donner ses disponibilités en avance`,
  AVAILABILITIES_ADVANCE_DAYS: `Délai minimum de notification (availabilities)`,
  WORKABLE_HOURS: `Heures de travail autorisées`,
  RESTRICT_AVAILABILITY: `Disponibilités restreintes`,
  WORKABLE_HOURS_START: `Heure de début (heures autorisées)`,
  WORKABLE_HOURS_END: `Heure de fin (heures autorisées)`,
  WEEKS: `Semaines`,
  DAYS: `jours`,
  HOURS: `heures`,
  MINUTES: `minutes`,
  SCHEDULING_SECTION: `Horaire`,
  AVAILABILITIES_SECTION: `Disponibilités`,
  EXPIRATION_SECTION: `Expiration`,
  CSV_EXPORT_NAME: `export_donnees_dembauche_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Création d'une donnée d'embauche`,
      SUMMARY: `Les données d'embauche permettent de filtrer les employés ainsi que d'appliquer des règles basées sur leurs contrats ou leurs permis.`
    },
    EDIT: {
      TITLE: `Modification d'une donnée d'embauche`,
      SUMMARY: `Les données d'embauche permettent de filtrer les employés ainsi que d'appliquer des règles basées sur leurs contrats ou leurs permis.`
    },
    NAME: {
      LABEL: `Nom de la donnée d'embauche`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement la repérer.`,
      PLACEHOLDER: `Entrez un nom pour la donnée d'embauche`
    },
    TYPE: {
      LABEL: `Type`,
      DESCRIPTION: `Permet de séparer les différents types de données d'embauche.`
    },
    IMPORTCODE: {
      LABEL: `Code d'importation`,
      DESCRIPTION: `Utilisé dans les outils d'importation afin d'assigner des données d'embauche à des utilisateurs.`,
      PLACEHOLDER: `Entrez le code d'importation`
    },
    HASVALIDPERIOD: {
      LABEL: `Possède une période de validité`,
      DESCRIPTION: `Lors de l'assignation d'une donnée d'embauche à un utilisateur, il sera possible d'ajouter une date de début et/ou une date de fin.`
    },
    NBHOURSMAX: {
      LABEL: `Nombre d'heures maximal`,
      DESCRIPTION: `Permet à un employé de ne pas dépasser son nombre d'heures autorisé.`,
      PLACEHOLDER: `Entrez le nombre d'heures`
    },
    DISPONIBILITIESAPPROVEDBYDEFAULT: {
      LABEL: `Approuver les requêtes de disponibilité automatiquement`,
      DESCRIPTION: `Lorsqu'un utilisateur soumet une requête de disponibilité, celle-ci sera autorisée par défaut par l'application.`
    },
    CANNOTUPDATEAVAILABILITIES: {
      LABEL: `Empêcher les employés de soumettre des requêtes de disponibilité`,
      DESCRIPTION: `Les employés ne pourront pas faire de demandes de disponibilités ni modifier celles déjà soumises.`
    },
    SENDEXPIREDEMAILS: {
      LABEL: `Envoyer un courriel d'expiration`,
      DESCRIPTION: `Un courriel sera envoyé à chaque nuit lorsque cette donnée d'embauche arrive à expiration. Les addresses auxquelles l'envoyer doivent être définies dans les paramètres de l'application.`
    },
    MINIMUMDISTANCEBETWEENSHIFTS: {
      LABEL: `Distance minimale entre des quarts de travail`,
      DESCRIPTION: `Les employées ne seront pas éligibles pour les quarts de travail qui débutent avant la fin de cette période.`,
      PLACEHOLDER: `Entrez la distance souhaitée`
    },
    FALLBACKID: {
      LABEL: `Données d'embauche à utiliser une fois expirée`,
      DESCRIPTION: `Lorsque cette donnée d'embauche ne sera plus valide, cette données d'embauche la remplacera.`
    },
    ACTIVATEWORKABLEHOURS: {
      LABEL: `Limiter les heures de travail autorisées`,
      DESCRIPTION: `Permet de s'assurer qu'un employé ne travaille pas à des heures où il n'est pas censé être en poste.`
    },
    WORKABLEHOURSTART: {
      LABEL: `Début minimal des quarts de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Choisisez l'heure à laquelle l’employé doit commencer son quart de travail au plus tôt`
    },
    WORKABLEHOUREND: {
      LABEL: `Fin maximal des quarts de travail`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Choisisez l'heure à laquelle l’employé doit terminer son quart de travail au plus tard`
    },
    MUSTSUBMITAVAILABILITIESINADVANCE: {
      LABEL: `Doit soumettre ses requêtes de disponibilité en avance`,
      DESCRIPTION: `Permet d'avertir les utilisateurs qu'ils doivent communiquer leurs disponibilités un certain nombre de jours avant que celles-ci ne commencent.`
    },
    SUBMITAVAILABILITIESINADVANCEDAYS: {
      LABEL: `Nombre de jours d'avance pour soumettre une requête de disponibilité :`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez le nombre de jours`
    },
    SUBMITAVAILABILITIESINADVANCETIME: {
      LABEL: `Heure de la journée`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Heure à utiliser pour la limite, dans le fuseau horaire de l'employé.`
    },
    RESTRICTAVAILABILITY: {
      LABEL: `Restreindre les disponibilités`,
      DESCRIPTION: `Permet de limiter les choix de plages de disponibilité de l'employé`
    },
    RESTRICTAVAILABILITYTOSCHEDULETYPES: {
      LABEL: `Plages horaires permises`,
      PLACEHOLDER: `Sélectionnez des types d'horaire`,
      DESCRIPTION: `Détermine les types d'horaire parmi lesquels l'employé pourra faire ses choix de disponbilités.`
    },
    ENABLEAVAILABILITYSUBMISSIONCUTOFF: {
      LABEL: `Activer la date limite pour les disponibilités`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Permet d'empêcher les employés ayant ce type de données d'embauche de soumettre des disponibilités pour une semaine à venir après une heure spécifique d'un jour dans la semaine. Nous recommandons d'expliquer le fonctionnement de la date limite dans le champ de description pour les disponibilités.`
    },
    AVAILABILITYSUBMISSIONCUTOFFDAYOFWEEK: {
      LABEL: `Jour de la semaine`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Jour à utiliser pour la date limite.`
    },
    AVAILABILITYSUBMISSIONCUTOFFTIME: {
      LABEL: `Heure de la journée`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Heure à utiliser pour la limite, dans le fuseau horaire de l'employé.`
    },
    AVAILABILITYSUBMISSIONCUTTOFFNUMBEROFWEEKSAHEAD: {
      LABEL: `Nombre de semaines d'avance`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Utilisez 1 pour la semaine prochaine et plus pour les autres semaines, entrer zéro (0) ne fera rien.`
    },
    NAME_REQUIRED: `Le nom de la donnée d'embauche est obligatoire.`,
    TYPE_REQUIRED: `Le type de la donnée d'embauche est obligatoire.`
  }
}
